<div class="main-panel">
  <!-- BEGIN : Main Content-->
  <div class="main-content">
    <div class="content-wrapper">
      <div>
        <section id="scroll-dynamic">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="form-section"><i class="ft-user"></i> Migration</h4>
                  <hr>
                  <br>
                  <form class="form form-horizontal">
                    <div class="form-body">

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group row">
                            <label class="col-md-1 label-control" for="userinput5">From </label>
                            <div class="col-md-3">
                              <select (change)="selectChangeHandlerDeviceFrom($event)"
                                class="browser-default custom-select">
                                <option selected>Select Device</option>
                                <option *ngFor="let item of Device" value="{{item.device_id}}">{{item.deviceName}}
                                </option>
                              </select>
                            </div>
                            <label class="col-md-1 label-control" for="userinput5">To </label>
                            <div class="col-md-3">
                              <select (change)="selectChangeHandlerDeviceTo($event)"
                                class="browser-default custom-select">
                                <option selected>Select Device</option>
                                <option *ngFor="let item of Device" value="{{item.device_id}}">{{item.deviceName}}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-2">
                              <div class="float-right">
                                <button class="btn btn-primary" (click)="MigrateDevice()">Migrate </button>
                              </div>
                            </div>


                          </div>
                        </div>




                      </div>
                    </div>
                  </form>


                </div>
                <div class="card-content" *ngIf="dataTable">
                  <div class="card-body card-dashboard table-responsive">

                    <table datatable id="example" class="display" cellspacing="0" width="100%">
                      <thead>
                        <tr>
                          <th>
                            <input type="checkbox" [checked]="isChecked" (click)="checkuncheckall()">
                          </th>

                          <th>User ID</th>
                          <th>Name</th>
                          <th>Priviledge</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of UserTemplates">
                          <td><input type="checkbox" [checked]="isChecked" (click)="CheckUser($event,item.userId)"></td>
                          <td>{{item.userId}}</td>
                          <td>{{item.userName}}</td>
                          <td>{{item.userPrivilledge}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div *ngIf="SummaryTogle" class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">


                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="form-section"><i class="ft-user"></i> Migrating Summary</h4>
                      <table class="table">


                        <thead>
                          <tr>
                            <th> Total Users</th>
                            <th> Accept Employee</th>
                            <th> Rejected Employee</th>
                          </tr>


                        </thead>
                        <tbody>
                          <tr>
                            <td>{{MigrationSummary.totalUsers}}</td>
                            <td>{{MigrationSummary.acccepted}}</td>
                            <td>{{MigrationSummary.rejected}}</td>
                          </tr>
                        </tbody>
                      </table>



                    </div>


                  </div>
                </div>

              </div>
            </div>
          </div>
          <div *ngIf="SummaryTogle" class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">


                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="form-section"><i class="ft-user"></i> Rejected Users Summary</h4>
                      <table datatable class="table table-responsive-sm text-center">
                        <thead>
                          <tr>
                            <th> UserID</th>
                            <th> User Name</th>
                            <th> Reason</th>
                          </tr>


                        </thead>
                        <tbody>
                          <tr *ngFor="let item of MigrationSummary.reJectedUserList">
                            <td>{{item.userID}}</td>
                            <td>{{item.username}}</td>
                            <td>{{item.remarks}}</td>

                          </tr>
                        </tbody>
                      </table>



                    </div>


                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>

    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <h3 style="color: white">Please Wait ... </h3>
  </ngx-spinner>
